/* eslint-disable */
import React, { useEffect, useState, useRef } from "react"
import styles from './Beat.module.css'
import { updateContext, updateGhostBeat, updateMouse } from '../../AnnotatorSlice'
import { useDispatch, useSelector } from 'react-redux';

const Beat = (prop) => {
    const dispatch = useDispatch()
    const {
        coordinates = [0,0],
        x = coordinates[0],
        y = coordinates[1],
        type,
        index,
        beatLabel,
        ghost = false,
   } = prop

    // 0 = Noise (Shown on Frontend)
    // 1 = Noise (Shown on Frontend)
    // 2 = Normal (Shown on Frontend)
    // 3 = VEB (Shown on Frontend)
    // 5 = SVEB (Shown on Frontend)

    const renderGhost = () => (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x},${y})`}>
                <circle  onMouseDown={clicked} r="7" fill="#8c8c8c" />
            </g>
        </svg>
        )
    const renderNoise = () => (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x},${y})`}>
                <circle onMouseDown={clicked} r="7" fill="#6CCA6E"/>
            </g>
            {/* <g id={`${index}`} transform={`translate(${x-8},${y-8})`}>
                <rect  onMouseDown={clicked} cx="-8" cy="-8" width="16" height="16" fill="#cacdd0" />
            </g> */}
        </svg>
        )
    const renderBeat = () => (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x},${y})`}>
                <circle onMouseDown={clicked} r="7" fill="#6CCA6E"/>
            </g>
        </svg>
        )
    const renderVe = () => (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x-11},${y-11})`}>
                <path  onMouseDown={clicked} cx="-11" cy="-11" d="M10 0L19.5263 16.5H0.473721L10 0Z" fill="#DC271B"/>
            </g>
        </svg>
        )
    const renderSVe = () => (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x-11},${y-11})`}>
                <path  onMouseDown={clicked} d="M0 10L10 0L20 10L10 20L0 10Z" fill="#5EC2FB"/>
            </g>
        </svg>
        )

    const renderOne = () => {
        switch(type){
            case 0:
                return renderGhost()
                break
            case 1:
                return renderNoise()
                break
            case 2:
                return renderBeat()
                break
            case 3:
                return renderVe()
                break
            case 4:
                return <g></g>
                break
            case 5:
                return renderSVe()
                break
            default:
                return <g></g>
                break
        }
    }
    const clicked = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if(type == 0) return
        // Right-click or Ctrl-Click (Mac): open the type dropdown immediately.
        // Plain left-click: arm drag state only. The menu opens on mouseup if
        // the marking was never actually dragged, so it stays hidden while
        // repositioning.
        const isMenuIntent = e.button === 2 || e.ctrlKey
        dispatch(updateGhostBeat({show:false}))
        if (!isMenuIntent) {
            dispatch(updateMouse({mousedown:true,mouseDownOnBeat:true,bStart:index,iStart:index,mouseDownOnBeatType:type,dragging:false}))
            return
        }
        dispatch(updateContext({
            show : true,
            data : {
                top:y,
                left:x,
                showDelete:true,
                beatIndex:index,
                additionalField:null,
            }
        }))
    }

	// return renderOne(type)

	const [hovered, setHovered] = useState(false)
	const labelName = beatLabel.find((label) => label.slug === type)?.name || type
	const fillColor = beatLabel.find((label) => label.slug === type)?.color || "#29292929"

	// The drag preview tracks the cursor, so it must not take pointer events:
	// otherwise it hovers itself and shows the DEFAULT_LEFT_CLICK sentinel name,
	// and it would swallow the mouseup that commits the drag.
	if (ghost) {
		return (
			<svg className={styles.beat}>
				<g transform={`translate(${x},${y})`} pointerEvents="none">
					<circle r="7" fill={fillColor} fillOpacity="0.5" />
				</g>
			</svg>
		)
	}

	return (
        <svg className={styles.beat}>
            <g id={`${index}`} transform={`translate(${x},${y})`}>
                <circle
                    onMouseDown={clicked}
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    r="7"
                    fill={fillColor}
                />
                {hovered && (
                    <g pointerEvents="none" transform="translate(0,-14)">
                        <rect x="-40" y="-16" width="80" height="18" rx="3" ry="3" fill="rgba(0,0,0,0.8)" />
                        <text x="0" y="-3" textAnchor="middle" fill="#fff" fontSize="12" fontFamily="sans-serif">{labelName}</text>
                    </g>
                )}
            </g>
        </svg>
    )
        
}

export default Beat
